<template>
  <div class="widgetContainer bg-white widgetContainer--scrollable pay">
    <div class="widgetContainer__header-fixed" v-if="paymentStatus == ''">
      <div class="navigationHeader">
        <div class="navigationHeader__inner">
          <span class="icon-Arrow-big-left cancel" @click="cancel" />
          <p class="title">
            {{ $t('payment_domesticwire_title') }}
          </p>
          <span class="el-icon-close" @click="drawerClose" />   
        </div>
      </div>
    </div>
    <div class="widgetContainer__body">
      <div class="pay__details">
        <el-form
          class="wise-form"
          :model="formData"
          :rules="formRules">
          <el-form-item
            class="is-no-asterisk"
            prop="contactDetails.wire.domestic.accountNumber"
            :label="$t('contact_Account_AccNo')">
            <AccountNumber
              v-model="formData.contactDetails.wire.domestic.accountNumber" />
          </el-form-item>

          <el-form-item
            class="is-no-asterisk"
            prop="contactDetails.wire.domestic.routingNumber"
            :label="$t('acc_detail_rout_title')">
            <RouteNumber v-model="formData.contactDetails.wire.domestic.routingNumber" />
          </el-form-item>

          <el-form-item
            class="is-no-asterisk"
            prop="contactDetails.wire.domestic.accountType"
            :label="$t('contact_Account_Type')">
            <el-select v-model="formData.contactDetails.wire.domestic.accountType">
              <el-option label="Personal Savings" value="personalSavings">
                Personal Savings
              </el-option>
              <el-option label="Personal Checking" value="personalChecking">
                Personal Checking
              </el-option>
              <el-option label="Business Savings" value="businessSavings">
                Business Savings
              </el-option>
              <el-option label="Business Checking" value="businessChecking">
                Business Checking
              </el-option>
            </el-select>
          </el-form-item>

          <el-form-item
            class="is-no-asterisk"
            prop="contactDetails.wire.domestic.bankName"
            :label="$t('contact_Account_Bank')">
            <el-input v-model="formData.contactDetails.wire.domestic.bankName" />
          </el-form-item>

          <el-form-item
            class="is-no-asterisk"
            prop="amount"
            :label="$t('pay_section_amount')">
            <Amount :precision="2" v-model="formData.amount" :masked="true" />
          </el-form-item>

          <el-form-item
            class="is-no-asterisk"
            prop="description"
            :label="$t('pay_row_purpose')">
            <el-input
              placeholder="Purpose of the payment"
              v-model="formData.description" />
          </el-form-item>
        </el-form>
      </div>
    </div>
    <div class="el-drawer__footer">
      <el-button
        type="primary"
        :disabled="!isFormValid"
        @click="next()"
        class="width-100 el-button__brand brand">
        {{ $t('pay') }}
      </el-button>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters, mapMutations } from 'vuex';
import Amount from '@/components/Amount';
import AccountNumber from '@/components/AccountNumber';
import RouteNumber from '@/components/RouteNumber';
import { payToContact } from '../utils/pay';

export default {
  components: {
    Amount,
    AccountNumber,
    RouteNumber
  },
  created() {
    if (!this.getPaymentType) this.$router.push('/pay/paymentType');

    if (!this.getPayDetails || !this.getPayDetails.address)
      this.$router.push('/pay/domestic-wire/address');
    else this.formData.contactDetails.wire.domestic.address = this.getPayDetails.address;

    if(this.getSelectedContactData.wire?.international){
      this.formData.contactDetails.wire.international = this.getSelectedContactData.wire.international;
      delete this.formData.contactDetails.wire.international.correspondentBank;
      delete this.formData.contactDetails.wire.international.correspondentBankAddress;
    }

    if (
      this.getSelectedContactData &&
      this.getSelectedContactData.wire &&
      this.getSelectedContactData.wire.domestic.accountType
    ) {
      ['accountNumber', 'accountType', 'bankName', 'routingNumber'].forEach(prop => {
        this.formData.contactDetails.wire.domestic[prop] = this.getSelectedContactData.wire.domestic[prop]
      })
    }
  },
  computed: {
    ...mapGetters('pay', ['getPaymentType', 'getPayDetails']),
    ...mapGetters('account', ['getSelectedAccount']),
    ...mapGetters('contact', ['getSelectedContactData']),
    isFormValid() {
      if (
        this.formData.amount !== '' &&
        this.formData.description !== '' &&
        /^[\w\s]*$/.test(this.formData.description) &&
        this.formData.contactDetails.wire.domestic.accountNumber &&
        this.formData.contactDetails.wire.domestic.accountNumber !== '' &&
        this.formData.contactDetails.wire.domestic.routingNumber !== '' &&
        this.formData.contactDetails.wire.domestic.accountType !== '' &&
        this.formData.contactDetails.wire.domestic.bankName !== '' &&
        this.formData.contactDetails.wire.domestic.accountType !== '' &&
        this.formData.contactDetails.wire.domestic.accountNumber.length >= 6 &&
        this.formData.contactDetails.wire.domestic.accountNumber.length <= 17 &&
        this.formData.contactDetails.wire.domestic.routingNumber.length === 9
      ) {
        const amount = parseFloat('' + this.formData.amount);
        return amount >= 0.05;
      }
      return false;
    }
  },
  data() {
    return {
      formData: {
        amount: '0',
        description: '',
        contactDetails: {
          wire: {
            domestic: {
              accountNumber: '',
              accountType: '',
              bankName: '',
              routingNumber: ''
            }
          }
        },
      },
      contactChange: false,
      formRules: {
        accountNumber: [
          {
            required: true,
            message: this.$t('accountNumberRequired'),
            trigger: 'blur'
          },
          {
            pattern: /^\d{6,17}$/,
            message: this.$t('accountNumberNotValid'),
            trigger: 'blur'
          }
        ],
        routingNumber: [
          {
            required: true,
            message: this.$t('routingNumberRequired'),
            trigger: 'blur'
          },
          {
            pattern: /^\d{9}$/,
            message: this.$t('routingNumberNotValid'),
            trigger: 'blur'
          }
        ],
        accountType: [
          {
            required: true,
            message: this.$t('accountTypeRequired'),
            trigger: 'blur'
          }
        ],
        bankName: [
          {
            required: true,
            message: this.$t('bankNameRequired'),
            trigger: 'blur'
          }
        ],
        description: [
          {
            validator: (rule,value,cb) => {
              if (/^[\w\s]*$/.test(value) === false) cb(new Error())
              else cb()
            },
            message: 'Special characters not allowed',
            trigger: ['change','blur']
          },
          {
            required: true,
            message: 'Required',
            trigger: ['change','blur']
          },
        ]
      },
      paymentStatus: '',
      paymentInfo: ''
    };
  },
  methods: {
    ...mapActions('account', ['getAccount']),
    ...mapMutations('transaction', ['setRecentTransactions']),
    cancel() {
      this.drawerBack();
    },
    async next() {
      if (this.isFormValid) {
        const loader = this.showLoader();
        try {
          if (
            this.getPayDetails.contactChange ||
            !this.getSelectedContactData ||
            !this.getSelectedContactData.wire ||
            this.getSelectedContactData.wire.domestic.accountNumber !==
              this.formData.contactDetails.wire.domestic.accountNumber ||
            this.getSelectedContactData.wire.domestic.routingNumber !==
              this.formData.contactDetails.wire.domestic.routingNumber ||
            this.getSelectedContactData.wire.domestic.accountType !==
              this.formData.contactDetails.wire.domestic.accountType ||
            this.getSelectedContactData.wire.domestic.bankName !==
              this.formData.contactDetails.wire.domestic.bankName
          ) {
            this.contactChange = true;
          }
          const data = await payToContact(
            'domestic',
            {
              accountId: this.getSelectedAccount.id,
              contactId: this.getSelectedContactData.id,
              amount: '' + this.formData.amount,
              description: this.formData.description,
              type: 'domestic'
            },
            this.contactChange
              ? {
                id: this.getSelectedContactData.id,

                ...this.formData.contactDetails
              }
              : null
          );

          this.paymentInfo = data;
          this.paymentStatus = data.status;
          this.setRecentTransactions([]);
          this.drawerPush('pay-success');
          loader.close();
        } catch (e) {
          this.apiErrorMessage(e);
          loader.close();
        }
      }
    },
    done() {
      this.goToDashboard();
    }
  }
};
</script>
<style lang="scss">
.pay {
  .widgetContainer__header-fixed {
    padding: 0;
  }

  .welcome__illustration {
    margin: 10% auto;
  }

  .header-title {
    font-size: 20px;
    font-weight: 600;
    line-height: 41px;
    padding-bottom: 6px;
    margin-bottom: 10px;
  }

  .widgetContainer__body {
    position: relative;
    padding-bottom: 70px;
  }

  &__header {
    font-size: 20px;
    font-weight: 600;
    line-height: 41px;
    padding: 6px 0;
  }

  &__details {
    .header-1 {
      text-transform: capitalize;
    }

    .sub-header {
      color: rgba(#3c3c43, 0.6);
      font-size: 13px;
      padding-bottom: 7px;
      text-transform: uppercase;
    }
  }
  .el-select {
    width: 100%;
  }
  .success-desc {
    font-size: 17px;
    color: #3c3c43;
    margin-bottom: 25px;
  }

  &__done-btn {
    width: 100%;
    &.is-disabled {
      opacity: 0.5;
    }
  }

  &__footer {
    position: absolute;
    bottom: 0;
    left: 0;
    width: 100%;
    background: #fff;
    padding: 16px;
    border-top: 1px solid #eeeeee;
    button {
      width: 100%;
    }
  }
}
</style>
